import {createAction, props} from '@ngrx/store';
import {TableSettings} from '../../interfaces/table-setting.interface';

export class BelegFilterTableActions {
  public static changeTableSettings = createAction(
    '[Beleg Filter Table] Changed table settings.',
    props<{tableSettings: TableSettings}>(),
  );
}
